import React, { useState } from 'react';
import { Close } from "@mui/icons-material";
import api from '../../services/api';

interface ColoniaFormProps {
  colonia?: any;
  onClose: () => void;
  onSaved: () => void;
}

const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
];

const ColoniaForm: React.FC<ColoniaFormProps> = ({ colonia, onClose, onSaved }) => {
  const [nome, setNome] = useState(colonia?.nome || '');
  const [codigo, setCodigo] = useState(colonia?.codigo || '');
  const [municipio, setMunicipio] = useState(colonia?.municipio || '');
  const [uf, setUf] = useState(colonia?.uf || '');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim()) {
      setErro('Informe o nome da colônia.');
      return;
    }
    setSalvando(true);
    setErro('');
    try {
      const payload = {
        nome: nome.trim(),
        codigo: codigo.trim() || null,
        municipio: municipio.trim() || null,
        uf: uf || null,
      };

      if (colonia?.uid_pesca_colonia) {
        await api.put(`/pesca/colonias/${colonia.uid_pesca_colonia}`, payload);
      } else {
        await api.post('/pesca/colonias', payload);
      }
      onSaved();
    } catch (err: any) {
      setErro(err?.response?.data?.message || 'Erro ao salvar colônia.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ margin: 0, color: 'var(--green-700, #00b37e)' }}>
            {colonia ? 'Editar Colônia' : 'Nova Colônia'}
          </h2>
          <Close style={{ cursor: 'pointer' }} onClick={onClose} />
        </div>

        <form onSubmit={handleSubmit}>
          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Nome *</label>
            <input style={inputStyle} value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Ex: Colônia de Pescadores Z-08 de Santos" />
          </div>

          <div style={fieldWrapStyle}>
            <label style={labelStyle}>Código</label>
            <input style={inputStyle} value={codigo} onChange={(e) => setCodigo(e.target.value)} />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <div style={{ ...fieldWrapStyle, flex: 1 }}>
              <label style={labelStyle}>Município</label>
              <input style={inputStyle} value={municipio} onChange={(e) => setMunicipio(e.target.value)} />
            </div>
            <div style={{ ...fieldWrapStyle, width: '90px' }}>
              <label style={labelStyle}>UF</label>
              <select style={inputStyle} value={uf} onChange={(e) => setUf(e.target.value)}>
                <option value="">-</option>
                {UFS.map((u) => <option key={u} value={u}>{u}</option>)}
              </select>
            </div>
          </div>

          {erro && <p style={{ color: '#f75a68', fontSize: '0.85rem' }}>{erro}</p>}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
            <button type="button" onClick={onClose} style={secondaryBtnStyle}>Cancelar</button>
            <button type="submit" disabled={salvando} style={primaryBtnStyle}>
              {salvando ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000,
};
const modalStyle: React.CSSProperties = {
  background: '#fff', borderRadius: '12px', padding: '24px',
  width: '90%', maxWidth: '480px', boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
};
const fieldWrapStyle: React.CSSProperties = { marginBottom: '14px' };
const labelStyle: React.CSSProperties = { display: 'block', fontSize: '0.8rem', color: '#666', marginBottom: '4px' };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #ddd', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
};
const primaryBtnStyle: React.CSSProperties = {
  padding: '8px 20px', borderRadius: '20px', border: 'none', background: '#03c9fe', color: '#fff', cursor: 'pointer',
};
const secondaryBtnStyle: React.CSSProperties = {
  padding: '8px 20px', borderRadius: '20px', border: '1px solid #ddd', background: '#fff', color: '#666', cursor: 'pointer',
};

export default ColoniaForm;
